import { Observable, EMPTY } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {
    handleError: any;
    constructor(
        public toasterService: ToastrService,
        private router: Router,
        private authService: AuthService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        let reqClone = request.clone(this.createRequest(request));
        const th = this;
        return next.handle(reqClone).pipe(
            catchError((error) => {
                const currentApiArray = reqClone.url?.split('/');
                const currentApi = currentApiArray[currentApiArray.length - 2];
                if(currentApi === 'login') {
                    throw error;
                } else {
                    return th.errorHandler(error)
                }
            }));
    }

    createRequest(request: any) {
        return {
            headers: request.headers.set('Authorization', this.authService.getAccessToken() ? 'Bearer ' + this.authService.getAccessToken() : ''),
            withCredentials: false
        }
    }

    // Customize the default error handler here if needed
    private errorHandler(error: any): Observable<HttpEvent<any>> {
        switch (error.status) {
            case 401: {
                console.log(error);
                //unauthorized
                if (error['error']['errors'] == 'User Not Found' || error['error']['errors'] == 'User is Inactive') {
                    this.toasterService.error(`Access Denied: Unauthorized Login Attempt`);
                }
                else {
                    this.toasterService.error(`Your session has expired. Please log in`);
                }
                this.logout();
                return EMPTY;
            }
            case 403: {
                //unauthorized
                this.toasterService.error(`Your session has expired. Please log in`);
                this.logout();
                return EMPTY;
            }
            case 400:
            case 409: {
                throw error;
            }
            default: {
                this.toasterService.error(`Oops, an unexpected error has occurred. Please try again later.`);
                break;
            }
        }
        throw error;
    }

    logout() {
        if (this.authService.isAuthorized()) {
            this.authService.removeToken();
            this.router.navigate(['/login']);
        } else {
            this.router.navigate(['/login']);
        }
    }
}
